// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1880":"86d097ef","8151":"4a34f6ce"}[chunkId] + ".chunk.css";
};